<div *ngIf='occupation.occupationRatios.length >= 3' class='total-occupation'>
  {{ 'FACILITIES_SUMMARY.FACILITY.TOTAL_OCCUPATION' | translate }}
  <div *ngIf='occupation.occupationRatios[3]; else occupationRatio' class='occupation-number'>
    {{
    occupation.occupationRatios[1].occupation +
    occupation.occupationRatios[2].occupation +
    occupation.occupationRatios[3].occupation
    }}
  </div>
  <ng-template #occupationRatio
  >
    <div class='occupation-number'>
      {{
      occupation.occupationRatios[1].occupation +
      occupation.occupationRatios[2].occupation
      }}
    </div>
  </ng-template
  >
  <div class='center'>
    {{ 'FACILITIES_SUMMARY.FACILITY.WORD_OFF' | translate }}
    {{ occupation.occupationRatios[0].capacity }}
  </div>
</div>
